import { render, staticRenderFns } from "./SecurityFallbackSettingsTab.vue?vue&type=template&id=b7dee0e8&scoped=true"
import script from "./SecurityFallbackSettingsTab.vue?vue&type=script&lang=js"
export * from "./SecurityFallbackSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./SecurityFallbackSettingsTab.vue?vue&type=style&index=0&id=b7dee0e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dee0e8",
  null
  
)

export default component.exports